import Repository from './Repository';

const resource = "/auth/bankaccounts";
export default {
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
    update(id, data) {
        return Repository.put(`${resource}/${id}/`, data);
    },
}